<template>
    <Link
        :key="link"
        v-if="!$store.state.is_loading"
        :post_link="link"
        class="post-newsletter"
        :id="id"
    >
        <span v-html="text"></span>
    </Link>
</template>

<script>
import Link from "@/components/ui/Link.vue";
import Button from "@/components/ui/Button.vue";

export default {
    name: "post-newsletter",

    props: {
        is_contact: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Button,
        Link
    },

    data() {
        return {
            text: "",
            button_text: "",
            link: "",
            id: ""
        };
    },

    mounted() {
        this.$ajax.get("/options").then(res => {
            if (this.is_contact) {
                this.link = res.data.contact.link;
                this.text = res.data.contact.text;
                this.id = "contact-post";
            } else {
                this.link = res.data.newsletter.link;
                this.text = res.data.newsletter.text;
                this.id = "newsletter-post";
            }

            this.$store.state.is_loading = false;
        });
    }
};
</script>

<style lang="scss">
.post-newsletter {
    padding: 1rem 1rem 1rem 2rem;
    margin: var(--padding) var(--padding) 0;
    background: var(--orange);
    display: flex;
    align-self: center;
    font-size: var(--large-size);
    justify-content: space-between;
    color: var(--white);

    &:hover {
        background: var(--white);
        color: var(--orange);
    }

    &:visited {
        color: var(--white);
        &:hover {
            color: var(--orange);
        }
    }

    span {
        line-height: 1.3;
    }
}

html.black-mode {
    .post-newsletter {
        background: var(--black);
        color: var(--white);
        &:hover {
            background: var(--white);
            color: var(--black);
        }
    }
}
@media only screen and (max-width: 767px) {
    .post-newsletter {
        margin: var(--padding) 0 0;
        padding: var(--padding-50) 0 var(--padding-75);
        text-align: center;
        span {
            margin: auto;
        }

        &:hover {
            background: var(--orange);
            color: var(--white);
        }
    }

    html.black-mode {
        .post-newsletter {
            &:hover {
                background: var(--black);
                color: var(--white);
            }
        }
    }
}
</style>
